import Hidden from '@material-ui/core/Hidden'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const VerticalTabs = (props) => {
  const mediumViewport = useMediaQuery('(min-width:600px)')

  return (
    <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
      <Hidden>
        <Tabs
          indicatorColor="primary"
          scrollButtons="on"
          textColor="primary"
          orientation={mediumViewport ? 'vertical' : 'horizontal'}
          variant="scrollable"
          value={props.value}
          onChange={props.onChange}
        >
          <Tab label="Principales" />
          <Tab label="Anexas sin control" />
          <Tab label="Anexas con control" />
        </Tabs>
      </Hidden>
    </div>
  )
}

export default VerticalTabs
